/**
 * Brand prioritization utility.
 * Starvie is the store's priority brand and should appear first
 * in all brand lists, filters, and navigation dropdowns.
 */

const PRIORITY_BRAND = "starvie";

/** Sort brands with Starvie always first, rest alphabetical */
export function sortBrandsWithPriority(brands: string[]): string[] {
  return [...brands].sort((a, b) => {
    const aIsPriority = a.toLowerCase() === PRIORITY_BRAND;
    const bIsPriority = b.toLowerCase() === PRIORITY_BRAND;
    if (aIsPriority && !bIsPriority) return -1;
    if (!aIsPriority && bIsPriority) return 1;
    return a.localeCompare(b);
  });
}

/** Check if a product brand is the priority brand */
export function isPriorityBrand(brand: string | null | undefined): boolean {
  return (brand || "").toLowerCase() === PRIORITY_BRAND;
}

/** Sort products so priority brand appears first (stable for same-brand) */
export function sortProductsByBrandPriority<T extends { brand: string }>(products: T[]): T[] {
  return [...products].sort((a, b) => {
    const aP = isPriorityBrand(a.brand) ? 0 : 1;
    const bP = isPriorityBrand(b.brand) ? 0 : 1;
    return aP - bP;
  });
}
